import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Candidates } from '../../models/candidates.model';
import { UsersService } from '../../services/users.service';
import { FunctionsService } from '../../services/functions.service';
import { HttpService } from '../../services/http.service';
import { Trainings } from '../../models/trainings.model';
import { Professions } from 'src/app/models/professions.model';
import { CandidatesProfiles } from '../../models/candidatesProfiles.model';
import { CandidatesExperiences } from 'src/app/models/candidatesExperiences.model';
import { AreaActivities } from '../../models/areaActivities.model';
import { CandidatesTrainings } from '../../models/candidatesTrainings.model';
import { CandidatesLanguages } from '../../models/candidatesLanguages.model';
import { Languages } from 'src/app/models/languages.model';
import { CandidatesSkills } from '../../models/candidatesSkills.model';
import { Skills } from '../../models/skills.model';
import { CandidatesCertificates } from 'src/app/models/candidatesCertificates.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-candidat-languages',
  templateUrl: './candidat-languages.component.html',
  styleUrls: ['./candidat-languages.component.scss']
})
export class CandidatLanguagesComponent implements OnInit {
  candidates: Candidates = new Candidates([]);
  candidateLanguageList: CandidatesLanguages[] = [];
  candidatesLanguages: CandidatesLanguages = new CandidatesLanguages({});
  languagesForm: FormGroup = new FormGroup({});
  languageList: Languages[] = [];
  candidateCertificateList: CandidatesCertificates[] = [];
  jobIDToApply: any;
  certificatFile: any = null;
  languageIsLoading: boolean = false;
  showBtnToGoApplyJob = false;
  candidatesProfiles: CandidatesProfiles = new CandidatesProfiles({});
  totalFillingRate = 0;
  personalInfoRate = 0;
  profileRate = 0;
  experienceRate = 0;
  trainingRate = 0;
  languageRate = 0;
  skillRate = 0;


  attestationFile: any = null;
  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService) {


    if (usersService.getUserType() != 'candidat') {
      this.router.navigate(['/not-found']);
    }

    this.candidates = this.usersService.getCurrentUser();

    if (localStorage.getItem('jobIDToApply') && localStorage.getItem('jobIDToApply') != undefined) {
      this.jobIDToApply = localStorage.getItem("jobIDToApply");

      this.showBtnToGoApplyJob = true;
    }
  }

  ngOnInit(): void {
    this.calculateTotalFillingRate();
    this.initLanguageForm();
  }

  calculateTotalFillingRate() {

    if (this.candidates.getGender() !== null && this.candidates.getGender() !== '') {
      this.personalInfoRate = 20;
    } else {
      this.personalInfoRate = 0;
    }

    if (this.candidatesProfiles.getProfessions() && this.candidatesProfiles.getProfessions().getLibelle() != undefined) {
      this.profileRate = 20;
    } else {
      this.profileRate = 0;
    }

    if (this.candidates.getCandidatesTrainings().length > 0) {
      this.trainingRate = 15;
    } else {
      this.trainingRate = 0;
    }

    if (this.candidates.getCandidatesLanguages().length > 0) {
      this.languageRate = 15;
    } else {
      this.languageRate = 0;
    }

    if (this.candidates.getCandidatesSkills().length > 0) {
      this.skillRate = 15;
    } else {
      this.skillRate = 0;
    }

    if (this.candidates.getCandidatesExperiences().length > 0) {
      this.experienceRate = 15;
    } else {
      this.experienceRate = 0;
    }

    this.totalFillingRate = this.personalInfoRate + this.profileRate + this.experienceRate + this.trainingRate + this.languageRate + this.skillRate;

    localStorage.setItem('totalFillingRate', JSON.stringify(this.totalFillingRate));
  }

  initLanguageForm() {
    console.log(1);
    this.calculateTotalFillingRate();
    this.getCandidateLanguages();
    this.languageList = this.functionsService.getLanguagesList();
    this.languagesForm = this.formBuilder.group({
      language_id: ['', Validators.required],
      level: ['', Validators.required],
    });
  }

  onSubmitLanguageForm(): any {

    let formValue: any = this.languagesForm.value;
    formValue['certificat'] = this.certificatFile;
    // console.log(formValue['attestation']);
    this.languageIsLoading = true;

    this.httpService.addCandidateLanguage(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.languageIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Langue ajoutée.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initLanguageForm();
          this.getCandidateLanguages();
        }
      },
      (error) => {
        console.log(error);
        this.languageIsLoading = false;
        if (error.error.message == 'CANDIDATE_LANGUAGE_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette langue a déjà été ajoutée.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeLanguage(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer cette langue ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateLanguage(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Langue supprimée.',
              });
              this.candidates = this.usersService.getCurrentUser();
              this.initLanguageForm();
              this.getCandidateLanguages();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }
  getCandidateLanguages() {
    const candidateLanguages: any = this.candidates.getCandidatesLanguages();

    this.candidateLanguageList = [];

    candidateLanguages.forEach((element: any) => {
      let candidatesLanguages = new CandidatesLanguages(element);
      this.candidateLanguageList.push(candidatesLanguages);
    });
    return this.candidateLanguageList;
  }

  async chooseCertificat() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le fichier',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Fichier selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.certificatFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }
}
